import React from "react";
import PropTypes from "prop-types";
import "./downloadPdfButton.style.scss";

const DownloadPdfButton = ({ handler, btn_small }) => {
  return (
    <button
      className={`download_btn ${
        btn_small ? "download_btn_small" : "download_btn_medium"
      }`}
      onClick={handler}
    >
      Download PDF
      <i className="fa fa-arrow-down bounce" aria-hidden="true"></i>
    </button>
  );
};

DownloadPdfButton.propTypes = {
  btn_small: PropTypes.bool,
  handler: PropTypes.func.isRequired,
};
export default DownloadPdfButton;



// WEBPACK FOOTER //
// ./src/components/common/buttons/downloadPdfButton/downloadPdfButton.jsx